export default "__VITE_ASSET__S1paeMA5__"